import { render, staticRenderFns } from "./table-detail.vue?vue&type=template&id=5066af9d&"
import script from "./table-detail.vue?vue&type=script&lang=js&"
export * from "./table-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports